<div *ngIf="workflowItem"
		[ngClass]="viewMode"
		[appWorkflowItem]="workflowItem"
		[appWorkflowItemData]
>
	<div *ngIf="viewMode === 'compact'" nz-row [nzGutter]="[16, 6]" class="top-row-with-sidebar-extra">
		<div nz-col [nzSpan]="viewMode === 'compact' ? 18 : 23" class="gutter-row">
			<div class="top-row-with-sidebar mb-3">
				<app-splitbutton [elements]="[cancelWorkflowSplitbutton]"></app-splitbutton>
			</div>
			<div *ngIf="viewMode === 'compact'">
				<div nz-row [nzGutter]="[16, 16]">
					<div nz-col [nzSpan]="24">
						<div *ngTemplateOutlet="overviewElements"></div>
					</div>
				</div>
			</div>
		</div>
		<div nz-col [nzSpan]="viewMode === 'compact' ? 6 : 0" *ngIf="viewMode === 'compact'">
			<workflow-projektsidebar [currentParticipant]="participant">
			</workflow-projektsidebar>
		</div>
	</div>
	<nz-modal *ngIf="viewMode === 'wizard'" nzVisible nzNoAnimation>
		<div class="wizard">
			<div class="titlerow">
				<div class="closeButtonColumn button-overview">
					<button nz-button nzType="secondary" type="button"
						(click)="showWorkflow()" class="big-back-button"
					>
						<i nz-icon nzType="close" class="big-icon"></i>
					</button>
				</div>
				<div class="titlecolumn title-overview">
					<h2 class="big-title">{{workflowItem.name}}</h2>
				</div>
				<div class="infoButtonColumn"></div>
			</div>
			<perfect-scrollbar>
				<div class="contentrow">
					<div *ngTemplateOutlet="overviewElements"></div>
				</div>
			</perfect-scrollbar>
		</div>
	</nz-modal>

	<ng-template #overviewElements>
		<div *ngIf="workflowItem && workflowItemStatus" nz-row [nzGutter]="[16, 6]">
			<div *ngFor="let questionGroup of workflowItem.groups, let i = index" nz-col [nzSpan]="24" [nzXXl]="6" [nzXl]="8" [nzLg]="12" [nzMd]="24"
				[hidden]="groupStatus[i]?.status === 'disabled'"
			>
				<nz-card class="card-tile" (click)="goToQuestion(i)" [ngClass]="{'disabled': !groupStatus[i]?.isEditable && !finishedAndLocked}">
					<nz-card-meta [nzTitle]="questionGroupTitle" [nzAvatar]="statusAvatar"></nz-card-meta>
					<div class="question-card-data div-table extra-space">
						<ng-container *ngIf="questionGroup.groupOverview?.length && !unfinishedProcedureGroup[i]"></ng-container>
						<workflow-overview-item *ngFor="let item of questionGroup.groupOverview" [config]="item" class="div-table-line"
												[finishedAndLocked]="finishedAndLocked"></workflow-overview-item>
					</div>
				</nz-card>

				<ng-template #questionGroupTitle>
					<div class="question-card-title">
						<h3 [ngClass]="{'small': groupStatus[i]?.hasMissingValue}">{{questionGroup.title}}</h3>
						<p *ngIf="groupStatus[i]?.hasMissingValue" class="fehlwert bordered">
							<workflow-missing-value-icon></workflow-missing-value-icon>
						</p>
					</div>
				</ng-template>
				<ng-template #statusAvatar>
					<i-feather
							*ngIf="groupStatus[i]?.status === 'finished'"
							name="check-circle"
							class="group-finished group-status"
							[ngClass]="{'disabled': !groupStatus[i]?.isEditable}"
					></i-feather>
					<i-feather
							*ngIf="groupStatus[i]?.status === 'edited'"
							name="alert-circle"
							class="group-edited group-status"
							[ngClass]="{'disabled': !groupStatus[i]?.isEditable}"
					></i-feather>
					<i-feather
							*ngIf="groupStatus[i]?.status === 'unstarted'"
							name="circle"
							class="group-unstarted group-status"
							[ngClass]="{'disabled': !groupStatus[i]?.isEditable}"
					></i-feather>
				</ng-template>
			</div>
		</div>
	</ng-template>

</div>

<nz-modal [(nzVisible)]="isConfirmDialogVisible"
					nzTitle="{{ 'workflow.end' | translate }}"
					(nzOnCancel)="handleCancelToDismissFinishWorkflow()"
					(nzOnOk)="handleOkToFinishWorkflow()"
>
	<ng-container *nzModalContent>
		{{ 'workflow.endWarning' | translate }}
	</ng-container>
</nz-modal>
